import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'lucide-react';
import { apiLogin } from '../../api';
import LoginPageStyle from '../styles&pics/LoginPageStyle';

const LoginPage = ({ setIsLoggedIn, setLoggeduser }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await apiLogin(username, password);
      
      if (response.token) {
        localStorage.setItem('authToken', response.token);
        localStorage.setItem('loggedInUser', username);
        setIsLoggedIn(true);
        setLoggeduser(username);
        // Dispatch custom event to update header
        window.dispatchEvent(new Event('loginStateChange'));
        navigate('/');
      } else {
        setError('Σφάλμα σύνδεσης. Παρακαλώ δοκιμάστε ξανά.');
      }
    } catch (err) {
      setError(err.message || 'Λάθος όνομα χρήστη ή κωδικός πρόσβασης.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <LoginPageStyle />
      <div className="auth-page">
        <div className="auth-container">
          <div className="auth-card">
            <div className="auth-header">
              <LogIn className="auth-icon" />
              <h1>Σύνδεση</h1>
              <p>Συνδεθείτε στον λογαριασμό σας</p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              {error && <div className="auth-error">{error}</div>}
              
              <div className="form-group">
                <label htmlFor="username">Όνομα Χρήστη</label>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Κωδικός Πρόσβασης</label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="auth-submit" disabled={loading}>
                {loading ? 'Σύνδεση...' : 'Σύνδεση'}
              </button>
            </form>

            <div className="auth-footer">
              <p>Δεν έχετε λογαριασμό;</p>
              <button onClick={() => navigate('/register')} className="auth-link">
                Εγγραφή
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
